import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import HelpIcon from '@mui/icons-material/Help';
import resourceNames, { ResourceNames } from './constants/resourceNames';
import actions, { Actions } from './constants/actions';

export type MenuPage = {
  resource: ResourceNames;
} | {
  title: string;
  href: string;
  openNewTab: boolean;
  icon: React.ComponentType;
  exact: boolean;
  permissions: Actions[];
}

export type MenuGroup = {
  title: string;
  pages: MenuPage[];
}

const menuGroups: MenuGroup[] = [
  {
    title: '',
    pages: [
      {
        title: 'Dashboard',
        href: '/',
        openNewTab: false,
        icon: DashboardIcon,
        exact: false,
        permissions: [],
      },
    ],
  },
  {
    title: 'Risk monitoring',
    pages: [
      { resource: resourceNames.CASES },
      { resource: resourceNames.PINGS },
      { resource: resourceNames.REQUESTS },
      { resource: resourceNames.REPORTS },
    ],
  },
  {
    title: 'Entities',
    pages: [
      { resource: resourceNames.ACCOUNT_ENTITIES },
      { resource: resourceNames.BUSINESSES },
      { resource: resourceNames.INDIVIDUALS },
      { resource: resourceNames.PRODUCTS },
      { resource: resourceNames.CARS },
    ],
  },
  {
    title: 'Risk setup',
    pages: [
      { resource: resourceNames.RISK_CLASSES },
      { resource: resourceNames.GROUPS },
      { resource: resourceNames.TRANSACTION_TYPES },
      { resource: resourceNames.PROCESSES },
      { resource: resourceNames.SIGNALS },
      { resource: resourceNames.RULES },
    ],
  },
  {
    title: 'Administration',
    pages: [
      {
        title: 'Access management',
        href: '/access-management',
        openNewTab: false,
        icon: PeopleIcon,
        exact: false,
        permissions: [
          actions.MEMBER_LIST,
          actions.API_KEY_LIST,
          actions.PERMISSION_ROLE_LIST,
          actions.ACCOUNT_SECURITY_UPDATE,
        ],
      },
      { resource: resourceNames.AUDIT_TRACKS },
      { resource: resourceNames.TAGS },
      { resource: resourceNames.FORMS },
      { resource: resourceNames.INTERFACE_SETTINGS },
      {
        href: 'https://support.pingwire.io',
        openNewTab: true,
        icon: HelpIcon,
        title: 'Help center',
        exact: true,
        permissions: [],
      },
    ],
  },
];

export default menuGroups;
